// import { story00 } from './story00'
import { story01 } from './story01'
import { story02 } from './story02'
import { story03 } from './story03'
import { story04 } from './story04'
import { story05 } from './story05'
import { story06 } from './story06'
import { story07 } from './story07'
import { story08 } from './story08'
import { story09 } from './story09'
import { story10 } from './story10'
import { story11 } from './story11'
import { story12 } from './story12'
import { story13 } from './story13'
import type { Article, ImpactType } from './types'

export { articleMetal } from './articleMetal'
export type {
  Article,
  ArticleRegion,
  ArticleContent,
  ArticleSection,
  ImpactType,
} from './types'

export const ARTICLES: Article[] = [
  // story00,
  story01,
  story02,
  story03,
  story04,
  story05,
  story06,
  story07,
  story08,
  story09,
  story10,
  story11,
  story12,
  story13,
]

/** All articles whose subject is the given metal slug, in running order. */
export const articlesForMetal = (slug: string) =>
  ARTICLES.filter((a) => a.metal.slug === slug).sort(
    (a, b) => a.order - b.order,
  )

/**
 * One impact's articles: the ones primary to it first, then the rest, each by `order`.
 * Without the split, the stories sitting in all three impacts would lead all three.
 */
export const articlesForImpact = (type: ImpactType) => {
  const group = (a: Article) => (a.impactList[0] === type ? 0 : 1)

  return ARTICLES.filter((a) => a.impactList.includes(type)).sort(
    (a, b) => group(a) - group(b) || a.order - b.order,
  )
}

/** The article at a route param slug, else `null`. Mirrors `metalBySlug`. */
export const articleBySlug = (slug: string | null) =>
  ARTICLES.find((a) => a.slug === slug) ?? null
